// extracted by mini-css-extract-plugin
module.exports = {"folderName":"DetaillsFolderNames_folderName__2RRy4"};